import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React from 'react';
import PropTypes from 'prop-types';
import 'wicg-inert';

var Inert = /*#__PURE__*/function (_React$Component) {
  _inherits(Inert, _React$Component);

  function Inert() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Inert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Inert)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.setContainerRef = function (ref) {
      _this.containerRef = ref;
    };

    return _this;
  }

  _createClass(Inert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.containerRef.inert = this.props.active;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.containerRef.inert = this.props.active;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        ref: this.setContainerRef
      }, this.props.children);
    }
  }]);

  Inert.displayName = "Inert";
  return Inert;
}(React.Component);

Inert.propTypes = {
  active: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};
export default Inert;